import { render, staticRenderFns } from "./MisCitas.vue?vue&type=template&id=7b64c52e&scoped=true"
import script from "./MisCitas.vue?vue&type=script&lang=js"
export * from "./MisCitas.vue?vue&type=script&lang=js"
import style0 from "./MisCitas.vue?vue&type=style&index=0&id=7b64c52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b64c52e",
  null
  
)

export default component.exports